import { Deserializer } from "jsonapi-serializer";
import { INTERNAL_SERVER_ERROR } from "../constants/response-status-codes";
import { Controller } from "../models/Controller";
import { genericError } from "../models/GenericError";
import { StoreEntityResult } from "../models/services/StoreEntityResult";
import { APIConnector } from "./api/APIConnector";
import { processServerError, getConstraintViolation } from "./utilities/ServiceError";

const apiConnector = new APIConnector();

/**
 * This request will update Discovery record, might perform additional valiation which attempts to talk to and
 * update the physical device itslef, then if updateType requires it will update the Controller/Terminal record as well.
 *
 * @param controller - the network settings to update
 * @param oldIpAddress - used to find the Terminal records to be updated
 */
export const updateNetworkSettings = async (controller: Controller, oldIpAddress: string) => {
    try {
        const record = {
            data: {
                type: "networkSettings",
                id: "0",
                attributes: {
                    discoveryId: controller.discoveryId,
                    updateType: controller.updateType,
                    forceChanges: controller.forceChanges ? 1 : 0,
                    synchroniseChangesToHardware: controller.synchroniseChangesToHardware,
                    wanIpAddress: controller.wanIpAddress,
                    oldIpAddress: oldIpAddress,
                    ipAddress: controller.ipAddress,
                    ipAddressStatic: controller.staticIpAddress ? 1 : 0,
                    gateway: controller.gateway,
                    gatewayStatic: controller.staticIpAddress ? 1 : 0,
                    netmask: controller.subnetMask,
                    netmaskStatic: controller.staticIpAddress ? 1 : 0,
                    safeIp: controller.safeIp ? 1 : 0,
                    hostName: controller.hostname,
                    hostPort: controller.outgoingPortFromEngine,
                    hostToCtrlPort: controller.incomingPortFromEngine,
                    termToCtrlPort: controller.incomingPortFromDC,
                    tlsUrl: controller.tlsUrl,
                    tlsMode: controller.tlsMode,
                    tlsPort: controller.tlsPort,
                },
            }
        }

        const url = `networkSettings`;
        let response: Response;

        await apiConnector.sendData(url, true, record).then(data => {
            response = data;
        }).catch(error => {
            return new Promise((resolve, reject) => {
                return reject(processServerError(error));
            })
        });

        return new Promise<StoreEntityResult>(async (resolve, reject) => {
            if (response) {
                const content = await response.json();
                if (content.errors) {
                    return reject({status: response.status, message: getConstraintViolation(content.errors[0].detail) })
                }
                new Deserializer().deserialize(content, (error, controller) => {
                    if (error) {
                        return reject({status: response.status, id: controller.id, success: false, message: genericError });
                    }
                    return resolve({ id: controller.id, success: true });
                })

                return;
            }

            return reject({status: INTERNAL_SERVER_ERROR, id: controller.id, success: false, message: genericError });
        })
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        })
    }
}
